import React from 'react'
import { Button, ButtonProps, useWalletModal} from '@mozartfinance/uikit'
import useI18n from 'hooks/useI18n'
import useAuth from 'hooks/useAuth'

const UnlockButton: React.FC<ButtonProps> = (props) => {
  // const TranslateString = useI18n()
  const { login, logout } = useAuth()
  const { onPresentConnectModal } = useWalletModal(login, logout)
  console.log("test props",props);

  return (
    <Button className='themeBouttonCrypto' onClick={onPresentConnectModal} {...props}>
      {/* {TranslateString(292, 'Unlock Wallet')} */} Connecter au wallet
    </Button>
  )
}

export default UnlockButton
